module.exports = __webpack_public_path__ + "b23897903e3de4c34bba1e5246cc5e75.png";